import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Initialize Auth State from LocalStorage
store.dispatch('auth/initializeAuth');

createApp(App).use(store).use(router).mount('#app')
